module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Profile_03-c3b7cb39a8d71b8ad1bad446b3b4a0a5.jpg";